<template>
	<div class="small-12 addForm viewInvoiceMenu animated fadeInRight border-top border-right" v-if="open_view_invoice_menu && invoice" v-bind:class="{ active: open_view_invoice_menu }">
        <div class="small-12 columns panelMenuWrapper">
            <div class="small-12 formTitle border-bottom">
                <h2 class="small-12 flex vertical-align justify-between">
                    <span class="float-left small-8">
						View Invoice
					</span>
                    <i class="material-icons-outlined transition" @click="closeViewInvoiceMenu()">cancel</i>
                </h2>
            </div>
            <tabs>
                <tab name="Invoice Details" :selected="true">
                    <div class="small-12 invoice">
                        <div class="small-12 invoiceHeader" :style="'background:url(' + background_image + '), linear-gradient(90deg, rgba(0,7,110,1) 0%, rgba(61,47,158,1) 35%, rgba(114,90,208,1) 100%);'">
                            <div class="small-12 status">
                                <div class="small-12 large-6">
                                    <span class="badge borderRadius4" v-if="invoice.attributes.status == 'draft'">Draft</span>
                                    <span class="badge borderRadius4" v-else-if="invoice.attributes.status == 'open'">Open</span>
                                    <span class="badge borderRadius4" v-else-if="invoice.attributes.status == 'paid'">Paid</span>
                                    <span class="badge borderRadius4" v-else-if="invoice.attributes.status == 'uncollectible'">Void</span>
                                    <span class="badge borderRadius4" v-else-if="invoice.attributes.status == 'pending'">Pending</span>
                                    <span class="badge borderRadius4" v-else>Late</span>
                                </div>
                                <div class="small-12 large-6 actions flex justify-right" v-if="future_item">
                                    <a class="borderRadius4 flex justify-center vertical-align" v-tooltip="'Send'">
                                        <i class="material-icons-outlined">north_east</i>
                                    </a>
                                </div>
                            </div>
                            <div class="small-12 title flex vertical-align">
                                <div class="small-12 large-6 name">
                                    <h1 class="small-12 text-overflow flex">
                                        <span class="small-12 text-overflow" v-if="company.attributes.name.dba">{{company.attributes.name.dba}}</span>
                                        <span class="small-12 text-overflow" v-else>{{company.attributes.name.legal}}</span>
                                    </h1>
                                    <p class="small-12 invoiceID text-overflow">
                                        inv_{{invoice.id}}
                                    </p>
                                </div>
                                <div class="small-12 large-6 address">
                                    <p class="small-12 flex">
                                        <span class="small-12 text-overflow">
                                            {{company.attributes.address.street_1}}
                                        </span>
                                        <span class="small-12 text-overflow">
                                            {{company.attributes.address.city}}, {{company.attributes.address.state}}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="small-12 invoiceBody">
                            <div class="small-12 overviewWrap">
                                <div class="small-12 invoiceOverview">
                                    <div class="small-12 large-7">
                                        <div class="small-12 title flex" style="padding-bottom:0;">
                                            <p>Invoice For</p>
                                        </div>
                                        <div class="small-12 resident">
                                            <p class="small-12 text-overflow">{{resident.attributes.contact_information.first_name}} {{resident.attributes.contact_information.last_name}}</p>
                                        </div>
                                        <div class="small-12 residentAddress">
                                            <p class="small-12 text-overflow">
                                                {{unit.attributes.address.street_1}}
                                            </p>
                                            <p class="small-12 text-overflow">
                                                {{unit.attributes.address.city}}, {{unit.attributes.address.state}}
                                            </p>
                                            <p class="small-12 text-overflow">
                                                Unit: {{unit.attributes.number}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="small-12 large-5 amountDue">
                                        <div class="small-12 title flex" style="padding-bottom:0;">
                                            <p>Amount Due</p>
                                        </div>
                                        <div class="small-12 amount">
                                            <h2>${{invoice.attributes.charge.total | convertCentsToDollars}}</h2>
                                        </div>
                                        <div class="small-12 dueDate">
                                            <span class="badge bgPrimaryBlue borderRadius4 flex justify-center">
                                                Due on<br/>{{invoice.attributes.due_on.date | unixToDate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="small-12 lineItems">
                                <div class="small-12 memo">
                                    <div class="small-12 title" style="padding-bottom:0;">
                                        <p>Description</p>
                                    </div>
                                    <div class="small-12 description">
                                        <p>{{invoice.attributes.description}}</p>
                                    </div>
                                </div>
                                <div class="small-12 table">
                                    <div class="small-12 tableHeader">
                                        <div class="small-12 tableRow">
                                            <div class="small-12 large-9 tableCell">
                                                <p class="small-12 text-overflow flex">Title</p>
                                            </div>
                                            <div class="small-12 large-3 tableCell">
                                                <p class="small-12 text-overflow flex justify-right">Amount</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="small-12 tableBody border-bottom">
                                        <ul class="small-12 float-left flex">
                                            <li class="small-12 tableRow" v-for="(lineItem, index) in invoice_line_items" :key="index">
                                                <div class="small-12 large-9">
                                                    <p class="small-12 text-overflow">
                                                        {{ lineItem.description }}
                                                    </p>    
                                                </div>
                                                <div class="small-12 large-3">
                                                    <p class="small-12 text-overflow flex justify-right">
                                                        ${{lineItem.amount | convertCentsToDollars}}
                                                    </p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="small-12 tableFooter flex justify-right">
                                        <div class="small-12 large-9 totals">
                                            <ul class="small-12 flex float-left">
                                                <li class="small-12 flex vertical-align">
                                                    <div class="small-12 large-6 totalLabel flex justify-right">
                                                        <p>Subtotal</p>
                                                    </div>
                                                    <div class="small-12 large-6 flex justify-right lineItemTotal">
                                                        <p>${{invoice.attributes.charge.subtotal | convertCentsToDollars}}</p>
                                                    </div>
                                                </li>
                                                <li class="small-12 flex vertical-align">
                                                    <div class="small-12 large-6 totalLabel flex justify-right">
                                                        <p>Paid to Date</p>
                                                    </div>
                                                    <div class="small-12 large-6 flex justify-right lineItemTotal">
                                                        <p>${{invoice.attributes.charge.total_paid | convertCentsToDollars}}</p>
                                                    </div>
                                                </li>
                                                <li class="small-12 flex vertical-align border-top">
                                                    <div class="small-12 large-6 totalLabel flex justify-right">
                                                        <p>Total</p>
                                                    </div>
                                                    <div class="small-12 large-6 flex justify-right lineItemTotal">
                                                        <p>${{amountRemaining | convertCentsToDollars}}</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab>
                <tab name="Fees" v-if="payment_method_set">
                    <div class="small-12 panelTitle" v-if="invoice.attributes.status !== 'paid'">
                        <h2>Estimated Fees<em class="cPrimary">*</em></h2>
                        <p class="small-12">
                            The fees displayed below are estimates only. Once your 
                            resident makes a payment towards the invoice, actual fees will show up 
                            here.
                        </p>
                    </div>
                    <div class="small-12 panelTitle" v-else>
                        <h2>Transaction Fees</h2>
                    </div>
                    <div class="small-12 feesBreakdownChart flex vertical-align">
                        <div class="small-8">
                            <div class="small-12 columns chart chart-line-s" style="margin-top:10px;" v-if="chartBothData && chartOptions || chartCardsData && chartOptions || chartACHData && chartOptions">
                                <div class="small-12 wrap">
                                    <pie-chart :chartOptions="chartOptions" :chartData="chartBothData" v-if="company.attributes.settings.payment_methods.cards && company.attributes.settings.payment_methods.ach"></pie-chart>
                                    <pie-chart :chartOptions="chartOptions" :chartData="chartCardsData" v-else-if="company.attributes.settings.payment_methods.cards"></pie-chart>
                                    <pie-chart :chartOptions="chartOptions" :chartData="chartACHData" v-else-if="company.attributes.settings.payment_methods.ach"></pie-chart>
                                </div>
                            </div>
                        </div>
                        <div class="small-4 chartLegend">
                            <ul class="small-12 float-left">
                                <li class="small-12 flex vertical-align" v-if="company.attributes.settings.payment_methods.cards">
                                    <span class="round bgSecondaryPurple"></span>
                                    <p>Stripe Card</p>
                                </li>
                                <li class="small-12 flex vertical-align" v-if="company.attributes.settings.payment_methods.ach">
                                    <span class="round bgSecondaryPurpleLight"></span>
                                    <p>Stripe ACH</p>
                                </li>
                                <li class="small-12 flex vertical-align">
                                    <span class="round bgPrimaryBlue"></span>
                                    <p>Nestd</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="small-12 fees table">
                        <div class="small-12 tableBody border-top">
                            <ul class="small-12 tableBody float-left flex vertical-align">
                                <li class="small-12 tableRow" v-if="company.attributes.settings.payment_methods.cards">
                                    <div class="small-8 tableCell">
                                        <p class="small-12 text-overflow text-right">
                                            <b>Stripe Card Fee:</b>
                                        </p>
                                    </div>
                                    <div class="small-4 tableCell">
                                        <p class="small-12 text-overflow text-right">
                                            <span>${{invoice.attributes.charge.card_fees.stripe.amount | convertCentsToDollars}}</span>
                                        </p>
                                    </div>
                                </li>
                                <li class="small-12 tableRow" v-if="company.attributes.settings.payment_methods.ach">
                                    <div class="small-8 tableCell">
                                        <p class="small-12 text-overflow text-right">
                                            <b>Stripe ACH Fee:</b>
                                        </p>
                                    </div>
                                    <div class="small-4 tableCell">
                                        <p class="small-12 text-overflow text-right">
                                            <span>${{invoice.attributes.charge.ach_fees.stripe.amount | convertCentsToDollars}}</span>
                                        </p>
                                    </div>
                                </li>
                                <li class="small-12 tableRow">
                                    <div class="small-8 tableCell">
                                        <p class="small-12 text-overflow text-right">
                                            <b>Nestd Fee:</b>
                                        </p>
                                    </div>
                                    <div class="small-4 tableCell">
                                        <p class="small-12 text-overflow text-right">
                                            <span>${{invoice.attributes.charge.card_fees.platform.amount | convertCentsToDollars}}</span>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <div class="small-12 tableFooter border-top flex vertical-align">
                                <div class="small-12" v-if="company.attributes.settings.payment_methods.cards">
                                    <div class="small-8 flex justify-right">
                                        <b>Card Transaction Total:</b>
                                    </div>
                                    <div class="small-4 flex justify-right">
                                        <h2>${{invoice.attributes.charge.card_fees.total_fees | convertCentsToDollars}}</h2>
                                    </div>
                                </div>
                                <div class="small-12" style="margin-top:10px;" v-if="company.attributes.settings.payment_methods.ach">
                                    <div class="small-8 flex justify-right">
                                        <b>ACH Transaction Total:</b>
                                    </div>
                                    <div class="small-4 flex justify-right">
                                        <h2>${{invoice.attributes.charge.ach_fees.total_fees | convertCentsToDollars}}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab>
                <tab name="Events">
                    <div class="small-12 events table">
                        <div class="small-12 tableHeader">
                            <div class="small-12 tableRow">
                                <div class="small-12 large-9 tableCell">
                                    <p class="small-12 text-overflow">
                                        Event
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="small-12 tableBody" v-if="events.length > 0">
                            <ul class="small-12 flex float-left">
                                <li class="small-12 tableRow border-bottom flex" v-for="(event, index) in events" :key="index">
                                    <div class="small-12 large-2 flex justify-center">
                                        <span class="round eventIcon flex justify-center vertical-align">
                                            <i class="material-icons-outlined">beenhere</i>
                                        </span>
                                    </div>
                                    <div class="small-12 large-10 columns border-left">
                                        <div class="small-12 title">
                                            <p class="small-12">
                                                {{event.attributes.title}}
                                            </p>
                                        </div>
                                        <div class="small-12 large-9 eventDate flex">
                                            <span class="badge bgGrey flex borderRadius4">
                                                {{event.meta.created_at | unixToDateTime}}
                                            </span>
                                        </div>
                                        <div class="small-12 large-3 actions flex justify-right">
                                            <a class="border borderRadius4 flex justify-center vertical-align" @click="openInvoiceEventModal(event)" v-tooltip="'View Event'">
                                                <i class="material-icons-outlined transition">north_east</i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="small-12 tableBody" v-else>
                            <ul class="small-12 columns flex animated fadeIn">
                                <li class="small-12">
                                    <div class="small-12 emptyResults flex justify-center">
                                        <picture class="small-12 flex justify-center">
                                            <img width="90" :src="empty_image" alt="Nestd Logo in a House">
                                        </picture>
                                        <h6 class="small-12 text-center">
                                            0 results found
                                        </h6>
                                        <p class="small-12 large-10 text-center">
                                            No invoice events have been added to this invoice yet.
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </tab>
            </tabs>
        </div>
        <div class="small-12 panelActions flex justify-center vertical-align border-top" v-if="rent">
            <a class="blueButton borderRadius4 flex justify-center vertical-align" @click="openEditInvoiceModal()" v-if="invoice.attributes.status !== 'paid' && invoice.attributes.status !== 'uncollectible' && invoice.attributes.status !== 'pending' && rent.attributes.term !== 'past'">
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">edit</i>
                Edit Invoice
            </a>
            <a class="disabledButton borderRadius4 flex justify-center vertical-align" v-else>
                <i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">edit</i>
                Edit Invoice
            </a>
            <a class="deleteButton borderRadius4 flex justify-center vertical-align" v-if="invoice.attributes.status !== 'paid' && invoice.attributes.status !== 'uncollectible' && invoice.attributes.status !== 'pending' && rent.attributes.term !== 'past'" @click="deleteInvoice()">
                Delete Invoice
            </a>
            <a class="deleteButton disabled borderRadius4 flex justify-center vertical-align" v-else>
                Delete Invoice
            </a>
        </div>
        <edit-invoice-modal :modal_action="openEditModal" :invoice_id="invoice.id" :lease_id="invoice.relationships.lease" :rent_id="invoice.relationships.rent" :user="user" @closeEditInvoiceModal="closeEditInvoiceModal" @refreshInvoice="refreshInvoice"/>
        <div class="smal-12 viewInvoiceEventDetails">
            <view-invoice-event-modal :event="selectedEvent" :resident="resident" :company="company" :user="user" :modal_action="openViewEventModal" @closeViewEventModal="closeViewEventModal"/>
        </div>
    </div>
</template>

<script>

	// Import the mixins
    import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
    import { DatesFilters } from '@/mixins/filters/DatesFilters'
    import { MoneyConversions } from '@/mixins/filters/MoneyConversions'
    import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

    // Get the events
    import { GetEvents } from '@/events/invoice-events/GetEvents'
    import { DeleteInvoice } from '@/events/invoices/DeleteInvoice'
    import { GetRent } from '@/events/rent/GetRent'
    
    // Import the components
    import Tabs from '@/components/framework/tabs/Tabs'
    import Tab from '@/components/framework/tabs/Tab'
    import EditInvoiceModal from '@/components/property/lease/invoices/EditInvoiceModal'
    import ViewInvoiceEventModal from '@/components/property/lease/invoices/ViewInvoiceEventModal'
    import PieChart from '@/components/framework/charts/PieChart.vue'

	export default {

		/*
		** Set the component name
		*/

		name: 'ViewInvoiceMenu',

		/*
		**  Register the components
		*/

		components: {

            Tabs,
            Tab,
            EditInvoiceModal,
            ViewInvoiceEventModal,
            PieChart

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            BugsnagService,
            DatesFilters,
            MoneyConversions,
            SpinnerMethods,
            GetEvents,
            DeleteInvoice,
            GetRent

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
				type: Boolean,
				default: false
            },

            invoice: {
                type: Object,
                default: () => null
            },

            resident: {
                type: Object,
                default: () => null
            },

            unit: {
                type: Object,
                default: () => null
            },

            company: {
                type: Object,
                default: () => null
            },

            user: {
                type: Object,
                default: () => null
            },

            lease: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

            open_view_invoice_menu: false,
            background_image: '',
            empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
            openEditModal: false,
            chartBothData: null,
            chartBothOptions: null,
            chartCardsData: null,
            chartCardsOptions: null,
            chartACHData: null,
			chartACHOptions: null,
			chartLabels: [],
            chartSeries: [],
            future_item: false,
            openViewEventModal: false,
            selectedEvent: null,
            payment_method_set: false,
            invoice_line_items: []

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

                    /*
                    **  Display the menu
                    **  @prop: @here
                    */

					if (menu_action) this.open_view_invoice_menu = true;

				}

            },

            invoice: {

				immediate: true, // Load on created
				handler(invoice) {

                    if (invoice) {
 
                        /*
                        **  Get the events
                        **  @method: @Events/Invoice-Events/GetEvents
                        */

                        this.getEventsHandler();

                        /*
                        **  Get the rent
                        **  @method: @here
                        */

                        this.getRentHandler(this.invoice.relationships.rent);

                        /*
                        **  Set the empty options
                        **  @method: @here
                        */

                        this.populateEmptyChartOptions();

                        /*
                        **  Set the chart
                        **  @method: @here
                        */

                        this.setChart();

                        /*
                        **  Set line items
                        **  @prop: @here
                        */

                        this.invoice_line_items = this.invoice.attributes.line_items;

                    }

				}

            },

            company: {

				immediate: true, // Load on created
				handler(company) {

					if (company) {
 
                        /*
                        **  Check if payment methods have been set
                        **  @method: @here
                        */

						this.checkPaymentMethods();

					}

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

            checkPaymentMethods: function() {

                /*
                **  Set the prop
                **  @prop: @here
                */

                try {

                    if (this.company.attributes.settings.payment_methods.cards || this.company.attributes.settings.payment_methods.ach) this.payment_method_set = true;

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Check for payment methods enablement to display the invoice fees chart.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'dtGoSOnE5fEr49Z6JLNG',
                        error: e
                    });

                }

			},

            populateEmptyChartOptions: function() {
 
                /*
                **  Populate the options
                **  @prop: @here
                */

                try {

                    this.chartOptions = {
                        responsive: true, 
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                            position: 'right'
                        },
                        tooltips: {
                        enabled: true,
                        },
                        cutoutPercentage: 60
                    };

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Set the chart options to display the invoice fees chart.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: '33dRNvgbVpYB1YKnW56u',
                        error: e
                    });

                }

            },
            
            setChart: function() {

                /*
                **  If company payment methods
                **  @prop: @here
                */

                try {

                    if (this.company.attributes.settings.payment_methods.cards && this.company.attributes.settings.payment_methods.ach) {

                        /*
                        **  Populate the chart data
                        **  @prop: @here
                        */

                        this.chartBothData = {

                            labels: ['Stripe Card Fee', 'Stripe ACH Fee', 'Nestd Fee'],
                            datasets: [
                                {
                                    backgroundColor: ['#3d2f9e', '#725ad0', '#44c6f6'],
                                    borderColor: '#ffffff',
                                    data: [(this.invoice.attributes.charge.card_fees.stripe.amount / 100).toFixed(2), (this.invoice.attributes.charge.ach_fees.stripe.amount / 100).toFixed(2), (this.invoice.attributes.charge.card_fees.platform.amount / 100).toFixed(2)]
                                }
                            ]

                        }

                    } else if (this.company.attributes.settings.payment_methods.cards) {

                        /*
                        **  Populate the chart data
                        **  @prop: @here
                        */

                        this.chartCardsData = {

                            labels: ['Stripe Card Fee', 'Nestd Fee'],
                            datasets: [
                                {
                                    backgroundColor: ['#3d2f9e', '#44c6f6'],
                                    borderColor: '#ffffff',
                                    data: [(this.invoice.attributes.charge.card_fees.stripe.amount / 100).toFixed(2), (this.invoice.attributes.charge.card_fees.platform.amount / 100).toFixed(2)]
                                }
                            ]

                        }

                    } else if (this.company.attributes.settings.payment_methods.ach) {

                        /*
                        **  Populate the chart data
                        **  @prop: @here
                        */

                        this.chartACHData = {

                            labels: ['Stripe ACH Fee', 'Nestd Fee'],
                            datasets: [
                                {
                                    backgroundColor: ['#725ad0', '#44c6f6'],
                                    borderColor: '#ffffff',
                                    data: [(this.invoice.attributes.charge.ach_fees.stripe.amount / 100).toFixed(2), (this.invoice.attributes.charge.ach_fees.platform.amount / 100).toFixed(2)]
                                }
                            ]

                        }

                    }

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Set the chart data to display the invoice fees chart.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'GgpxatI4M0kevN5YIWqZ',
                        error: e
                    });

                }

			},

			closeViewInvoiceMenu: function() {

                /*
                **  Close the menu
                **  @prop: @here
                */

                try {

                    /*
                    **  Set the menu prop
                    **  @prop: @here
                    */

                    this.open_view_invoice_menu = false;
 
                    /*
                    **  Emit the event
                    **  @service: @Vue
                    */

                    this.$emit('closeViewInvoiceMenu', true);

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Closing the view invoice menu.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'LHeO9lTzI205w8D8UrfO',
                        error: e
                    });

                }

            },

            refreshInvoice: function(value) {

                /*
                **  Emit the event
                **  @service: @Vue
                */

                try {

                    this.$emit('refreshInvoice', value);

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Emitting the refresh invoice event.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'UnYWzNNAzRQJW2iU0vIc',
                        error: e
                    });

                }

            },

            openEditInvoiceModal: function() {

                /*
                **  Set the modal prop
                **  @prop: @here
                */

                try {

                    this.openEditModal = true;

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Opening the edit invoice modal.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'qlNWDBrn4ZNYuvevvVg2',
                        error: e
                    });

                }
                

            },

            closeEditInvoiceModal: function() {

                /*
                **  Set the modal prop
                **  @prop: @here
                */

                try {

                    this.openEditModal = false;

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Closing the edit invoice modal.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'sCl3SmtktZpx1HOsrT4R',
                        error: e
                    });

                }

            },

            openInvoiceEventModal: function(event) {

                /*
                **  Open the invoice event modal
                **  @prop: @here
                */

                try {

                    /*
                    **  Set the modal prop
                    **  @prop: @here
                    */

                    this.openViewEventModal = true;
 
                    /*
                    **  Set the event prop
                    **  @prop: @here
                    */

                    this.selectedEvent = event;

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Open the invoice event modal.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'jcfiznS31YYC0gUCGivG',
                        error: e
                    });

                }

            },

            closeViewEventModal: function() {

                /*
                **  Set the view event modal prop
                **  @prop: @here
                */

                try {

                    /*
                    **  Set the modal prop
                    **  @prop: @here
                    */

                    this.openViewEventModal = false;

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Close the invoice event modal.',
                        errorType: 'Application',
                        section: 'Invoice',
                        uid: 'EW4iXf3Dtr7m0UXjebju',
                        error: e
                    });

                }

            },

            deleteInvoice: function() {

                /*
                **  Show confirmation
                **  @service: @SweetAlert2
                */

                this.$swal({

                    title: 'Are you sure you want to delete the invoice?',
                    showCancelButton: true,
                    confirmButtonText: `Delete`,
                    confirmButtonColor: '#18bbf7',
                    cancelButtonText: `Cancel`

                }).then((result) => {
                    
                    /*
                    **  If user confirms
                    */

                    if (result.isConfirmed) {

                        /* 
                        ** Show the spinner
                        ** @mixin: @Helpers/SpinnerMethods
                        */

                        this.showSpinner();

                        /*
                        **  Delete the invoice
                        **  @method: @Events/Invoices/DeleteInvoice
                        */

                        this.deleteInvoiceHandler();
                        
                    }

                });

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			amountRemaining: function() {

                return this.invoice.attributes.charge.total - this.invoice.attributes.charge.total_paid;

            }

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>